'use strict';

const PALETTES = Object.freeze([
  ['#46e6ff', '#214dff'], ['#ff5d8f', '#8a2cff'], ['#ffb238', '#ff4d37'],
  ['#55f59a', '#079c78'], ['#9d7bff', '#5531c7'], ['#ffe36a', '#d47b00'],
  ['#58c8ff', '#1262ad'], ['#ff7b54', '#b52b39'], ['#86ffef', '#077e9a'],
  ['#f088ff', '#9322ba'], ['#e8f1ff', '#61769e']
]);

class Boss {
  constructor(config, assetService, bounds) {
    this.assetService = assetService;
    this.bounds = bounds;
    this.visualRadius = 94;
    this.radius = 48;
    this.reset(config);
  }

  reset(config) {
    this.config = config;
    this.maxHealth = Math.max(1, Number(config.health) || 1);
    this.health = this.maxHealth;
    this.x = (this.bounds.left + this.bounds.right) / 2;
    this.y = this.bounds.top + 145;
    this.time = 0;
    this.flash = 0;
    this.dead = false;
  }

  update(dt) {
    if (this.dead) return;
    this.time += dt;
    this.flash = Math.max(0, this.flash - dt);
    const center = (this.bounds.left + this.bounds.right) / 2;
    const amplitude = Math.max(0, (this.bounds.right - this.bounds.left) / 2 - this.visualRadius - 24);
    const targetX = center + Math.sin(this.time * 0.78) * amplitude;
    const maximumStep = Math.max(0, Number(this.config.moveSpeed) || 0) * dt;
    this.x += Math.max(-maximumStep, Math.min(maximumStep, targetX - this.x));
  }

  takeDamage(amount) {
    if (this.dead) return false;
    this.health = Math.max(0, this.health - Math.max(0, Number(amount) || 0));
    this.flash = 0.08;
    if (this.health > 0) return false;
    this.dead = true;
    return true;
  }

  getHitCircle() {
    return { x: this.x, y: this.y + 12, radius: this.radius };
  }

  draw(ctx) {
    const variant = this.config.variant || { paletteIndex: 0, armorIndex: 0 };
    const palette = PALETTES[variant.paletteIndex % PALETTES.length];
    const animalImage = this.assetService && this.assetService.getAnimal(this.config.level);
    const image = animalImage || (this.assetService && this.assetService.get('rabbit'));
    ctx.save();
    ctx.translate(this.x, this.y);
    const bob = Math.sin(this.time * 2.2) * 5;
    ctx.translate(0, bob);
    ctx.shadowColor = palette[0];
    ctx.shadowBlur = this.flash > 0 ? 38 : 22;
    if (image && image.complete !== false) {
      const previousFilter = ctx.filter;
      ctx.filter = `hue-rotate(${variant.paletteIndex * 29}deg) saturate(1.12) brightness(${this.flash > 0 ? 1.8 : 1})`;
      ctx.drawImage(image, -this.visualRadius, -this.visualRadius, this.visualRadius * 2, this.visualRadius * 2);
      ctx.filter = previousFilter;
    } else {
      this.drawFallback(ctx, palette);
    }
    if (!animalImage) {
      this.drawArmor(ctx, palette, variant.armorIndex || 0);
      this.drawWeapon(ctx, palette, (this.config.patterns || [])[0]);
      this.drawExpression(ctx, palette);
    }
    if (this.flash > 0) {
      ctx.globalAlpha = 0.5;
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      ctx.arc(0, 5, this.visualRadius * 0.72, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  }

  drawFallback(ctx, palette) {
    ctx.fillStyle = '#f7f8ff';
    ctx.strokeStyle = palette[1];
    ctx.lineWidth = 6;
    ctx.beginPath();
    ctx.ellipse(-34, -55, 20, 55, -0.12, 0, Math.PI * 2);
    ctx.ellipse(34, -55, 20, 55, 0.12, 0, Math.PI * 2);
    ctx.fill(); ctx.stroke();
    ctx.beginPath(); ctx.arc(0, 15, 68, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
  }

  drawArmor(ctx, palette, armorIndex) {
    ctx.strokeStyle = palette[0];
    ctx.fillStyle = `${palette[1]}99`;
    ctx.lineWidth = 4 + (armorIndex % 3);
    const plates = 2 + (armorIndex % 4);
    for (let index = 0; index < plates; index += 1) {
      const side = index % 2 ? 1 : -1;
      const y = 6 + Math.floor(index / 2) * 26;
      ctx.beginPath();
      ctx.moveTo(side * 42, y - 18);
      ctx.lineTo(side * 78, y - 5);
      ctx.lineTo(side * 62, y + 18);
      ctx.lineTo(side * 32, y + 10);
      ctx.closePath();
      ctx.fill(); ctx.stroke();
    }
    ctx.beginPath();
    ctx.moveTo(0, -22); ctx.lineTo(18, -5); ctx.lineTo(0, 14); ctx.lineTo(-18, -5); ctx.closePath();
    ctx.fill(); ctx.stroke();
  }

  drawWeapon(ctx, palette, pattern) {
    ctx.strokeStyle = palette[0];
    ctx.fillStyle = palette[1];
    ctx.lineWidth = 4;
    const radius = pattern === 'ringBurst' ? 22 : 15;
    ctx.beginPath(); ctx.arc(0, 68, radius, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
    if (pattern === 'crossCarrot' || pattern === 'sweepWall' || pattern === 'mixedCarrot') {
      ctx.beginPath(); ctx.moveTo(-42, 62); ctx.lineTo(42, 74); ctx.moveTo(42, 62); ctx.lineTo(-42, 74); ctx.stroke();
    }
  }

  drawExpression(ctx, palette) {
    ctx.fillStyle = '#ff7a35';
    ctx.shadowColor = palette[0];
    ctx.shadowBlur = 8;
    ctx.beginPath(); ctx.ellipse(-25, 0, 8, 5, -0.2, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(25, 0, 8, 5, 0.2, 0, Math.PI * 2); ctx.fill();
  }
}

module.exports = Boss;
